"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _axios = _interopRequireDefault(require("axios"));

var _reactResponsiveModal = _interopRequireDefault(require("react-responsive-modal"));

var _reactSelectV = _interopRequireDefault(require("react-select-v2"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactDropzone = _interopRequireDefault(require("react-dropzone"));

var _reactSwitch = _interopRequireDefault(require("react-switch"));

var _functions = require("../../util/functions");

require("rc-checkbox/assets/index.css");

var _fontawesomeSvgCore = require("@fortawesome/fontawesome-svg-core");

var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");

var _reactFontawesome = require("@fortawesome/react-fontawesome");

require("react-dropdown/style.css");

require("./DownloadPdf.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

_fontawesomeSvgCore.library.add(_freeSolidSvgIcons.faCircleNotch);

var reactDropdownStyles = {
  control: function control(styles, _ref) {
    var data = _ref.data,
        isDisabled = _ref.isDisabled,
        isFocused = _ref.isFocused,
        isSelected = _ref.isSelected;
    return _objectSpread({}, styles, {
      border: 0,
      // This line disable the blue border
      boxShadow: 0,
      fontSize: 16,
      color: '#5B6770',
      '&:hover': {
        border: 0
      }
    });
  },
  singleValue: function singleValue() {
    return {
      color: '#5B6770',
      fontSize: 16
    };
  },
  placeholder: function placeholder() {
    return {
      color: '#BDC2C6'
    };
  },
  dropdownIndicator: function dropdownIndicator() {
    return {
      color: '#596770',
      paddingTop: '4px'
    };
  },
  indicatorSeparator: function indicatorSeparator() {
    return null;
  },
  option: function option(styles, _ref2) {
    var data = _ref2.data,
        isDisabled = _ref2.isDisabled,
        isFocused = _ref2.isFocused,
        isSelected = _ref2.isSelected;
    return _objectSpread({}, styles, {
      marginTop: '0px',
      '&:hover': {
        color: '#FFF',
        cursor: 'pointer'
      },
      '&:isSelected': {
        color: '#FFF'
      },
      '&:isFocused': {
        color: '#FFF'
      }
    });
  }
};

var DownloadPdf =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(DownloadPdf, _PureComponent);

  function DownloadPdf(props) {
    var _this;

    _classCallCheck(this, DownloadPdf);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DownloadPdf).call(this, props));
    _this.handleOpenModal = _this.handleOpenModal.bind(_assertThisInitialized(_this));
    _this.handleCloseModal = _this.handleCloseModal.bind(_assertThisInitialized(_this));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handleSubmit = _this.handleSubmit.bind(_assertThisInitialized(_this));
    _this.handleSelectDropdown = _this.handleSelectDropdown.bind(_assertThisInitialized(_this));
    _this.handleDropzoneChange = _this.handleDropzoneChange.bind(_assertThisInitialized(_this));
    _this.handleEnterPress = _this.handleEnterPress.bind(_assertThisInitialized(_this));
    _this.handleChangeCheckBox = _this.handleChangeCheckBox.bind(_assertThisInitialized(_this));
    _this.handleShowLogo = _this.handleShowLogo.bind(_assertThisInitialized(_this));
    _this.state = {
      config: null,
      waitingForPdf: false,
      userLogo: null,
      openModal: _this.props.openModalOnLoad,
      errorGeneratingPdf: false,
      showLogo: true,
      accentColor: '#05A9B1' // Create ref for the accent styles

    };
    _this.styleRef = _react.default.createRef();
    return _this;
  } // Set up the state to have default values for the dynamically loaded inputs


  _createClass(DownloadPdf, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var styles = getComputedStyle(this.styleRef.current);
      this.setState({
        accentColor: (0, _functions.convertRgbToHex)(styles.color)
      }); // Get the config for the app

      this.getConfig();
    }
    /********************************************* 
     * Async methods for api interactions
    **********************************************/

  }, {
    key: "getConfig",
    value: function () {
      var _getConfig = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var _this$props, dataspanApiUrl, token, configId, requestId;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props = this.props, dataspanApiUrl = _this$props.dataspanApiUrl, token = _this$props.token, configId = _this$props.configId;

                if (!(token !== undefined)) {
                  _context.next = 4;
                  break;
                }

                // Get the document config from Dataspan
                requestId = {
                  method: 'GET',
                  url: "".concat(dataspanApiUrl, "/pdf/").concat(configId, "/")
                };
                return _context.abrupt("return", (0, _axios.default)(requestId).then(function (d) {
                  if (d.status === 404) {
                    return;
                  } else {
                    return d.data;
                  }
                }).then(function (data) {
                  // If the ID exists then get the logo itself
                  if (data.id === configId) {
                    // Store the config for later user (on a reinitialize)
                    _this2.setState({
                      config: data
                    });

                    _this2.initializeInputs(data); // // Get the logo once the config has been loaded


                    _this2.getUserLogo();
                  }
                }).catch(function (error) {
                  console.error(error);
                }));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getConfig() {
        return _getConfig.apply(this, arguments);
      }

      return getConfig;
    }()
  }, {
    key: "getUserLogo",
    value: function () {
      var _getUserLogo = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        var _this3 = this;

        var _this$props2, dpdApiUrl, token, clientEmail, isAnonymous, requestId;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$props2 = this.props, dpdApiUrl = _this$props2.dpdApiUrl, token = _this$props2.token, clientEmail = _this$props2.clientEmail, isAnonymous = _this$props2.isAnonymous;

                if (!(token !== 'undefined' && clientEmail && !isAnonymous)) {
                  _context2.next = 4;
                  break;
                }

                // Get the client's logo id from DPD - DPD stores and handles all client logos rather
                // than DataSpan
                requestId = {
                  method: 'GET',
                  url: "".concat(dpdApiUrl, "/api/image/logo/").concat(clientEmail, "/id/"),
                  headers: {
                    Authorization: token && "Token ".concat(token)
                  }
                };
                return _context2.abrupt("return", (0, _axios.default)(requestId).then(function (d) {
                  if (d.status === 404) {
                    return;
                  } else {
                    return d.data;
                  }
                }).then(function (data) {
                  // If the ID exists then get the logo itself
                  if (data.id) {
                    _this3.loadUserLogo(data.id);
                  }
                }).catch(function (error) {
                  console.error(error);
                }));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getUserLogo() {
        return _getUserLogo.apply(this, arguments);
      }

      return getUserLogo;
    }() // Load the logo into state

  }, {
    key: "loadUserLogo",
    value: function loadUserLogo(id) {
      var dpdApiUrl = this.props.dpdApiUrl; // Put together the URL to the logo

      var imageUrl = dpdApiUrl + '/api/image/logo/lookup/?id=' + id; // If there any logo inputs then update with the latest
      // url for the user

      var inputsWithLogo = this.state.inputs.map(function (input) {
        var updatedInput = Object.assign({}, input);

        if (updatedInput.inputType === 'logo') {
          updatedInput.value = imageUrl;
        }

        return updatedInput;
      }); // Save the logo

      this.setState({
        userLogo: {
          'imageId': id,
          'imageUrl': imageUrl
        },
        inputs: inputsWithLogo
      });
    } // Save a user's logo using DPD

  }, {
    key: "saveUserLogo",
    value: function () {
      var _saveUserLogo = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee3(fileToSave) {
        var _this4 = this;

        var _this$props3, dpdApiUrl, token, clientEmail, isAnonymous, formData, request;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this$props3 = this.props, dpdApiUrl = _this$props3.dpdApiUrl, token = _this$props3.token, clientEmail = _this$props3.clientEmail, isAnonymous = _this$props3.isAnonymous;

                if (!(token !== 'undefined' && clientEmail || isAnonymous)) {
                  _context3.next = 8;
                  break;
                }

                formData = new FormData();
                formData.append('imageData', fileToSave);
                formData.append('clientEmail', clientEmail);
                formData.append('fileName', fileToSave.name);

                if (!isAnonymous) {
                  request = {
                    method: 'POST',
                    url: "".concat(dpdApiUrl, "/api/image/logo/"),
                    data: formData,
                    headers: {
                      Authorization: token && "Token ".concat(token)
                    }
                  };
                } else {
                  request = {
                    method: 'POST',
                    url: "".concat(dpdApiUrl, "/api/image/logo/add_anon/"),
                    data: formData
                  };
                }

                return _context3.abrupt("return", (0, _axios.default)(request).then(function (d) {
                  if (d.status === 404) {
                    return;
                  } else {
                    return d.data;
                  }
                }).then(function (data) {
                  // Save the new id if the post was successful
                  if (data.id) {
                    _this4.loadUserLogo(data.id);
                  }
                }).catch(function (error) {
                  console.error(error);
                }));

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function saveUserLogo(_x) {
        return _saveUserLogo.apply(this, arguments);
      }

      return saveUserLogo;
    }()
  }, {
    key: "generatePdf",
    value: function () {
      var _generatePdf = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee4(documentProperties, adhocInputs, outputName) {
        var _this5 = this;

        var _this$props4, dataspanApiUrl, token, clientEmail, isAnonymous, configId, inputs, body, request;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this$props4 = this.props, dataspanApiUrl = _this$props4.dataspanApiUrl, token = _this$props4.token, clientEmail = _this$props4.clientEmail, isAnonymous = _this$props4.isAnonymous, configId = _this$props4.configId; // Don't send in the input if its value is empty

                inputs = adhocInputs.filter(function (input) {
                  return input.value !== undefined && input.value !== null && input.value !== '';
                }).map(function (input) {
                  return {
                    'name': input.name,
                    'type': input.type,
                    'value': input.value
                  };
                });
                body = {
                  clientEmail: clientEmail,
                  teamSiteId: documentProperties.teamSiteId,
                  libraryContentVersionId: documentProperties.libraryContentVersionId,
                  outputName: outputName,
                  adhocInputs: inputs,
                  id: configId
                };

                if (!(token !== 'undefined' && clientEmail || isAnonymous)) {
                  _context4.next = 6;
                  break;
                }

                // If this is an anonymous generation then don't add the token
                if (!isAnonymous) {
                  request = {
                    method: 'POST',
                    responseType: 'blob',
                    url: "".concat(dataspanApiUrl, "/pdf/generate/"),
                    data: body,
                    headers: {
                      'Content-Type': 'application/json',
                      Authorization: token && "Token ".concat(token)
                    }
                  };
                } else {
                  request = {
                    method: 'POST',
                    responseType: 'blob',
                    url: "".concat(dataspanApiUrl, "/pdf/generate_with_id/"),
                    data: body,
                    headers: {
                      'Content-Type': 'application/json'
                    }
                  };
                }

                return _context4.abrupt("return", (0, _axios.default)(request).then(function (response) {
                  // If the generate has been cancelled then ignore the save
                  if (_this5.state.waitingForPdf) {
                    //1. Create a Blob from the PDF Stream
                    var file = new Blob([response.data], {
                      type: 'application/pdf'
                    }); // 2. Create blob link to download

                    var url = URL.createObjectURL(file);
                    var link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', "".concat(outputName, ".pdf")); // 3. Append to html page

                    document.body.appendChild(link); // 4. Force download

                    link.click(); // 5. Clean up and remove the link

                    link.parentNode.removeChild(link);

                    _this5.handleCloseModal();
                  }
                }).catch(function (error) {
                  console.error(error); // Set the error

                  _this5.setState({
                    errorGeneratingPdf: true
                  }); // this.handleCloseModal();

                }));

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function generatePdf(_x2, _x3, _x4) {
        return _generatePdf.apply(this, arguments);
      }

      return generatePdf;
    }()
    /********************************************* 
    * Input methods and change handlers
    **********************************************/
    // Wipe out the inputs and set back to original defaults

  }, {
    key: "initializeInputs",
    value: function initializeInputs(config) {
      var _this6 = this;

      if (config && config.adhocInputs) {
        // Initialize the input 
        var initializedInputs = config.adhocInputs.map(function (input) {
          var updatedInput = Object.assign({}, input);

          if (updatedInput.inputType === 'logo') {
            updatedInput.value = _this6.state.userLogo ? _this6.state.userLogo.imageUrl : null;
          }

          return updatedInput;
        });
        this.setState({
          docConfig: config,
          documentProperties: {
            teamSiteId: config.teamSiteId,
            libraryContentVersionId: config.libraryContentVersionId,
            outputName: config.outputName,
            contentName: config.contentName
          },
          inputs: initializedInputs
        }); // Update the inputs with the passed in Adhoc inputs (if the calling app wants to 'hard code' inputs)            

        this.updatePropAdhocInputs(config);
      }
    } // Update all inputs with the passed into Adhoc Inputs (via prop adhocInput).

  }, {
    key: "updatePropAdhocInputs",
    value: function updatePropAdhocInputs(config) {
      var _this7 = this;

      var adhocInputs = this.props.adhocInputs;

      if (config && config.adhocInputs && adhocInputs) {
        // Initialize the input 
        var updatedInputs = config.adhocInputs.map(function (input) {
          var updatedInput = Object.assign({}, input); // Ensure the logo is always added back from state. This could be overriden below if necessary

          if (updatedInput.inputType === 'logo') {
            updatedInput.value = _this7.state.userLogo ? _this7.state.userLogo.imageUrl : null;
          }

          var matchingAdhocInput = adhocInputs.filter(function (adhocInput) {
            return adhocInput.name === updatedInput.name;
          }); // Set the value of the input to the incoming prop adhoc input value

          if (matchingAdhocInput.length === 1) {
            updatedInput.value = matchingAdhocInput[0].value;
            updatedInput.label = matchingAdhocInput[0].label ? matchingAdhocInput[0].label : updatedInput.label; // If the input is a dropdown then set the label too (in case the output name relies on it)

            if (updatedInput.inputType === 'dropdown') {
              var matchingOption = updatedInput.options.filter(function (option) {
                return option.value === updatedInput.value;
              });

              if (matchingOption.length === 1) {
                updatedInput.value = matchingOption[0].value;
                updatedInput.label = matchingOption[0].label;
              }
            }
          }

          return updatedInput;
        });
        this.setState({
          inputs: updatedInputs
        });
      }
    } // Iterate the inputs and ensure all are filled in

  }, {
    key: "allInputsValid",
    value: function allInputsValid() {
      var inputs = this.state.inputs;
      var allComplete = false;

      if (inputs) {
        allComplete = true; // Loop over each input and check the values

        inputs.forEach(function (input) {
          if ((input.optional === null || input.optional === false) && (input.value === undefined || input.value === null || input.value === '')) {
            allComplete = false;
          }
        });
      }

      return allComplete;
    } // Handle open of modal

  }, {
    key: "handleOpenModal",
    value: function handleOpenModal() {
      // Submit right away if all the inputs are there and the app hasn't
      // been overriden to always show the modal
      if (this.allInputsValid() && this.props.submitOnLoad) {
        this.handleSubmit();
      } else {
        this.setState({
          openModal: true
        });
      }
    } // Handle close of modal

  }, {
    key: "handleCloseModal",
    value: function handleCloseModal() {
      this.setState({
        openModal: false,
        waitingForPdf: false,
        errorGeneratingPdf: false
      });
      this.initializeInputs(this.state.config);
    } // Handle all updates

  }, {
    key: "updateInput",
    value: function updateInput(name, value, label) {
      // Update the input
      var updatedInputs = this.state.inputs.map(function (input) {
        var updatedInput = Object.assign({}, input);

        if (updatedInput.name === name) {
          updatedInput.value = value;
          updatedInput.label = label;
        }

        return updatedInput;
      });
      this.setState({
        inputs: updatedInputs
      });
    } // Update the state with changes to inputs

  }, {
    key: "handleChange",
    value: function handleChange(event) {
      this.updateInput(event.target.name, event.target.value, event.target.value);
    } // Update the state with changes to checkbox inputs

  }, {
    key: "handleChangeCheckBox",
    value: function handleChangeCheckBox(name, value) {
      this.updateInput(name, value, value);
    } // Handle events from drop downs

  }, {
    key: "handleSelectDropdown",
    value: function handleSelectDropdown(name, value, label) {
      this.updateInput(name, value, label);
    } // Handle events from dropzones

  }, {
    key: "handleDropzoneChange",
    value: function handleDropzoneChange(input, acceptedFiles) {
      if (acceptedFiles.length > 0) {
        this.saveUserLogo(acceptedFiles[0]);
      }
    } // Handle showing or hiding the logo

  }, {
    key: "handleShowLogo",
    value: function handleShowLogo() {
      var _this8 = this;

      // If there is a logo then update the value (based on whether the user wants to show/hide it)
      if (this.state.userLogo) {
        var imageUrl = this.state.userLogo.imageUrl; // Turn on or off the logo inputs

        var inputsWithLogo = this.state.inputs.map(function (input) {
          var updatedInput = Object.assign({}, input); // showLogo hasn't been updated yet so check the opposite to see if it needs adding or removing

          if (updatedInput.inputType === 'logo' && !_this8.state.showLogo) {
            updatedInput.value = imageUrl;
          } else if (updatedInput.inputType === 'logo' && _this8.state.showLogo) {
            updatedInput.value = null;
          }

          return updatedInput;
        });
        this.setState({
          inputs: inputsWithLogo,
          showLogo: !this.state.showLogo
        });
      } else {
        this.setState({
          showLogo: !this.state.showLogo
        });
      }
    } // Handle enter press (if button enabled)

  }, {
    key: "handleEnterPress",
    value: function handleEnterPress(event) {
      if (event.keyCode === 13 && this.allInputsValid()) {
        this.handleSubmit();
      }
    } // Submit the inputs to pdf generator

  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      var _this$state = this.state,
          inputs = _this$state.inputs,
          documentProperties = _this$state.documentProperties; // Update the output name if necessary

      var outputName = documentProperties.outputName;
      inputs.forEach(function (input) {
        outputName = outputName.replace("[[" + input.name + "]]", input.label ? input.label : '');
      }); // Close the model and show the waiting indicator

      this.setState({
        openModal: false,
        waitingForPdf: true
      }); // Generate the pdf

      this.generatePdf(documentProperties, inputs, outputName); // Reset all fields

      this.initializeInputs(this.state.config);
    }
  }, {
    key: "render",
    value: function render() {
      var _this9 = this;

      var _this$props5 = this.props,
          downloadButtonText = _this$props5.downloadButtonText,
          cancelButtonText = _this$props5.cancelButtonText,
          modalTitleText = _this$props5.modalTitleText,
          waitingMessageText = _this$props5.waitingMessageText,
          initialButtonText = _this$props5.initialButtonText,
          errorGeneratingPdfText = _this$props5.errorGeneratingPdfText,
          openModalOnLoad = _this$props5.openModalOnLoad,
          closeWindowText = _this$props5.closeWindowText;
      var _this$state2 = this.state,
          waitingForPdf = _this$state2.waitingForPdf,
          inputs = _this$state2.inputs,
          openModal = _this$state2.openModal,
          errorGeneratingPdf = _this$state2.errorGeneratingPdf,
          showLogo = _this$state2.showLogo,
          accentColor = _this$state2.accentColor;
      var inputFields = inputs ? inputs.map(function (input) {
        switch (input.inputType) {
          case 'text':
            return _react.default.createElement("div", {
              className: "input-row",
              key: input.name
            }, _react.default.createElement("input", {
              className: (0, _classnames.default)(input.value === null && (input.optional === null || input.optional === false) ? 'invalid' : ''),
              type: input.inputType,
              name: input.name,
              value: input.value ? input.value : '',
              onChange: _this9.handleChange,
              placeholder: input.placeholder
            }));

          case 'textarea':
            return _react.default.createElement("div", {
              className: "input-row",
              key: input.name
            }, _react.default.createElement("textarea", {
              rows: "4",
              className: (0, _classnames.default)(input.value === null && (input.optional === null || input.optional === false) ? 'invalid' : ''),
              type: input.type,
              name: input.name,
              value: input.value ? input.value : '',
              onChange: _this9.handleChange,
              placeholder: input.placeholder
            }));

          case 'dropdown':
            return _react.default.createElement("div", {
              className: "input-row",
              key: input.name
            }, _react.default.createElement(_reactSelectV.default, {
              className: (0, _classnames.default)('wt-dropdown', input.value === null && (input.optional === null || input.optional === false) ? 'invalid' : ''),
              placeholder: input.placeholder,
              onChange: function onChange(selectedItem) {
                _this9.handleSelectDropdown(input.name, selectedItem.value, selectedItem.label);
              },
              styles: reactDropdownStyles,
              theme: function theme(_theme) {
                return _objectSpread({}, _theme, {
                  borderRadius: 0,
                  colors: _objectSpread({}, _theme.colors, {
                    primary25: accentColor,
                    primary: accentColor
                  })
                });
              },
              options: input.options,
              isMulti: false,
              value: input.value ? {
                'value': input.value,
                'label': input.label
              } : null
            }));

          case 'logo':
            return _react.default.createElement("div", {
              className: "input-row",
              key: input.name
            }, _react.default.createElement("div", {
              className: "switch-label"
            }, _react.default.createElement(_reactSwitch.default, {
              onChange: _this9.handleShowLogo,
              checked: showLogo,
              handleDiameter: 21,
              width: 51,
              height: 25,
              uncheckedIcon: false,
              checkedIcon: false // disabled={saveInProgress}
              ,
              offColor: "#BDC2C6",
              onColor: accentColor,
              activeBoxShadow: "0 0 2px 3px ".concat(accentColor)
            }), _react.default.createElement("div", null, _react.default.createElement("label", null, "\xA0 Display your logo"))), showLogo ? _react.default.createElement("div", {
              className: (0, _classnames.default)('image-row', input.value === null && (input.optional === null || input.optional === false) ? 'invalid' : '', input.value === null && input.optional === true ? 'empty' : '')
            }, _react.default.createElement(_reactDropzone.default, {
              onDrop: function onDrop(acceptedFiles) {
                console.log(acceptedFiles);

                _this9.handleDropzoneChange(input, acceptedFiles);
              }
            }, function (_ref3) {
              var getRootProps = _ref3.getRootProps,
                  getInputProps = _ref3.getInputProps;
              return _react.default.createElement("section", {
                className: (0, _classnames.default)('dropzone-section')
              }, _react.default.createElement("div", _extends({}, getRootProps(), {
                className: (0, _classnames.default)('dropzone', input.value === null && (input.optional === null || input.optional === false) ? 'invalid' : '')
              }), _react.default.createElement("input", _extends({}, getInputProps(), {
                accept: "image/png, image/jpeg, image/gif"
              })), _react.default.createElement("p", null, input.placeholder)));
            }), input.value ? _react.default.createElement("div", {
              className: "image-preview"
            }, _react.default.createElement("img", {
              src: input.value,
              alt: "logo"
            })) : null) : null);

          case 'checkbox':
            return _react.default.createElement("div", {
              className: "input-row",
              key: input.name
            }, _react.default.createElement("div", {
              className: "switch-label"
            }, _react.default.createElement(_reactSwitch.default, {
              onChange: _this9.handleChangeCheckBox.bind(_this9, input.name, !input.value),
              checked: input.value,
              handleDiameter: 21,
              width: 51,
              height: 25,
              uncheckedIcon: false,
              checkedIcon: false // disabled={saveInProgress}
              ,
              offColor: "#BDC2C6",
              onColor: accentColor,
              activeBoxShadow: "0 0 2px 3px ".concat(accentColor)
            }), _react.default.createElement("label", null, "\xA0 ", input.placeholder)));

          default:
            return null;
        }
      }) : null;
      return (// Show the button for download
        _react.default.createElement("div", {
          className: "download-pdf"
        }, _react.default.createElement("div", {
          className: "accent-color",
          ref: this.styleRef
        }), openModalOnLoad === false ? _react.default.createElement("button", {
          onClick: this.handleOpenModal
        }, initialButtonText) : null, //  Show configuration modal
        openModal && waitingForPdf === false ? _react.default.createElement("div", {
          onKeyDown: this.handleEnterPress
        }, _react.default.createElement(_reactResponsiveModal.default, {
          open: openModal === true,
          onClose: this.handleCloseModal,
          showCloseIcon: false,
          focusTrapped: false,
          classNames: {
            overlay: 'modal-overlay',
            modal: 'customize-pdf'
          },
          closeOnOverlayClick: false // Stops user from closing when clicking off modal
          ,
          closeOnEsc: true,
          center: true
        }, _react.default.createElement("div", {
          className: "customize-pdf-container"
        }, _react.default.createElement("div", {
          className: "modal-title"
        }, modalTitleText), _react.default.createElement("div", null, _react.default.createElement("div", {
          className: "input-values"
        }, inputFields), _react.default.createElement("div", {
          className: "action-buttons"
        }, _react.default.createElement("div", {
          className: "button-spot"
        }, _react.default.createElement("button", {
          onClick: this.handleSubmit,
          disabled: !this.allInputsValid()
        }, downloadButtonText)), _react.default.createElement("div", {
          className: "button-spot"
        }, _react.default.createElement("button", {
          onClick: this.handleCloseModal
        }, cancelButtonText))))))) //  Show waiting modal if pdf generation is in progress
        : waitingForPdf && openModal === false ? _react.default.createElement("div", null, _react.default.createElement(_reactResponsiveModal.default, {
          open: waitingForPdf === true,
          showCloseIcon: false,
          onClose: this.handleCloseModal,
          focusTrapped: false,
          classNames: {
            overlay: 'modal-overlay',
            modal: 'waiting-for-pdf'
          },
          closeOnOverlayClick: false // Stops user from closing when clicking off modal
          ,
          closeOnEsc: true,
          center: true
        }, _react.default.createElement("div", {
          className: "waiting-for-pdf-container"
        }, _react.default.createElement("div", {
          className: "waiting-for-pdf-container-message"
        }, errorGeneratingPdf ? '' : waitingMessageText), _react.default.createElement("div", {
          className: "waiting-for-pdf-container-loading"
        }, errorGeneratingPdf ? _react.default.createElement("p", null, errorGeneratingPdfText) : _react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
          icon: "circle-notch",
          size: "3x",
          className: "waiting-icon",
          spin: true
        })), _react.default.createElement("div", {
          className: "waiting-for-pdf-container-cancel"
        }, _react.default.createElement("button", {
          onClick: this.handleCloseModal
        }, cancelButtonText))))) : null, openModalOnLoad === true && openModal === false && waitingForPdf === false ? _react.default.createElement("div", {
          className: "close-window"
        }, closeWindowText) : null)
      );
    }
  }]);

  return DownloadPdf;
}(_react.PureComponent);

exports.default = DownloadPdf;

_defineProperty(DownloadPdf, "defaultProps", {
  initialButtonText: 'Download',
  downloadButtonText: 'Download',
  cancelButtonText: 'Cancel',
  modalTitleText: 'Customize Your Document',
  previewText: 'Preview',
  waitingMessageText: 'Please wait while your document is generated',
  closeWindowText: 'You can now close this window',
  token: '',
  dataspanApiUrl: 'https://dataspanapi.wisdomtree.com',
  dpdApiUrl: 'https://dpd.wisdomtree.com',
  clientEmail: '',
  configId: '',
  adhocInputs: null,
  errorGeneratingPdfText: 'There was an error generating your document. Please try again later.',
  submitOnLoad: true,
  isAnonymous: false,
  openModalOnLoad: false
});

DownloadPdf.propTypes = {
  /**
   * Text for the initial button added to any app
   */
  initialButtonText: _propTypes.default.string,

  /**
   * Text for the download button
   */
  downloadButtonText: _propTypes.default.string,

  /**
   * Text for the cancel button
   */
  cancelButtonText: _propTypes.default.string,

  /**
   * Text for the title of the customize modal
   */
  modalTitleText: _propTypes.default.string,

  /**
   * Waiting text when the pdf is generating
   */
  waitingMessageText: _propTypes.default.string,

  /**
   * Text for when the window closes
   */
  closeWindowText: _propTypes.default.string,

  /**
   * Token for the DPD/Dataspan APIs (required)
   */
  token: _propTypes.default.string.isRequired,

  /**
   * ID of the Config for the Seismic document. Used to retrieve the config
   * when using the DownloadPdf component
   */
  configId: _propTypes.default.string,

  /**
   * Client Email of the user generating the pdf (required)
   */
  clientEmail: _propTypes.default.string.isRequired,

  /**
   * Dataspan API url
   */
  dataspanApiUrl: _propTypes.default.string,

  /**
   * DPD API url
   */
  dpdApiUrl: _propTypes.default.string,

  /**
   * Error message for pdf generation failure
   */
  errorGeneratingPdfText: _propTypes.default.string,

  /**
   * Optional array of adhoc input values in the form:
   * [{
   *   "name":"family",
   *   "type":"string",
   *   "value":"WisdomTree"
   *  }]
   */
  adhocInputs: _propTypes.default.array,

  /**
   * If you want to force the modal to open then set this prop to false (even if all inputs
   * are satisfied the model will open)
   */
  submitOnLoad: _propTypes.default.bool,

  /**
   * Set to true if the component is to be used anonymously - we don't have a token to 
   * authorize against Dataspan/DPD
   */
  isAnonymous: _propTypes.default.bool,

  /**
   * Open the modal directly and don't show the button
   */
  openModalOnLoad: _propTypes.default.bool
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/wt-react/dist/components/DownloadPdf/DownloadPdf.js
// module id = 1046
// module chunks = 0